import React from 'react';
import { useLayout } from 'shared/contexts/LayoutContext';

const MetaButton = (item) => {
    const { openModal } = useLayout();

    return (
        <button 
            className="relative group" 
            onClick={(e) => {
                e.stopPropagation();
                openModal(item);
            }}
        >
            <span className="block">{item?.meta?.name}</span>
            <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                {item?.meta?.type}
            </span>
        </button>
    );
};

export default MetaButton;